import useActiveInspectionFromState from './useActiveInspectionFromState';
import useActiveInteractionFromState from './useActiveInteractionFromState';

export default {
    useActiveInspectionFromState,
    useActiveInteractionFromState,
};
